// extracted by mini-css-extract-plugin
export default {"cls1":"mGXmv8j4xnJBz9cpZKs_","cls2":"T4d7pUr9LKQJ3MuhfVFi mGXmv8j4xnJBz9cpZKs_"};